export default __webpack_public_path__ + "static/media/annex9.6557aff8.png";